import { HYDRATE } from 'next-redux-wrapper'
import { createAppSlice } from './createAppSlice'

/**
 * Modal state
 */
interface ModalData {
  open: boolean
}

export interface ModalState {
  data: ModalData | null
}
const intialModalState: ModalState = {
  data: {
    open: false,
  },
}
export const navSlice = createAppSlice({
  name: 'nav',
  initialState: intialModalState,
  reducers: {
    setOnFlyoutWillOpen(state) {
      state.data.open = true
    },
    setOnFlyoutWillClose(state) {
      state.data.open = false
    },
  },
  selectors: {
    selectNavOpen: (state) => state.data.open,
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        //@ts-ignore
        ...action.payload.nav,
      }
    })
  },
})

export const { setOnFlyoutWillOpen, setOnFlyoutWillClose } = navSlice.actions
export const { selectNavOpen } = navSlice.selectors

export default navSlice
